import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Home } from "./components/Home";
import { NavMenu } from "./components/NavMenu";
import Quotation from "./components/Quotation";
import Paymentgateawaye from "./components/PaymentGateaway";
import Paymentsummery from "./components/PaymentSummery";
import pageCall from "./pageCall";
import PaymentSuccessOrFailDumy from "./components/PaymentSuccessOrFailDumy";
import HomePage from "./TravelNewVersion/mainPages/HomePage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import QuotationPage from "./TravelNewVersion/mainPages/QuotationPage";
//import { OtherLink } from './components/OtherLink';

const App = () => {
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <NavMenu />
            <Routes>
                {/*<Route path='/' Component={Home} />*/}
                <Route path="/" Component={HomePage} />
                {/*<Route path='/Quotation' Component={Quotation} />*/}
                <Route path="/Quotation" Component={QuotationPage} />
                <Route path="/Proposal" Component={Paymentgateawaye} />
                <Route path="/PaymentSummery" Component={Paymentsummery} />
                <Route path="/paymentresult" Component={PaymentSuccessOrFailDumy} />
            </Routes>
        </>
    );
};
export default App;
